import { useState, useEffect } from "react";
import { Grid, Item } from "@mui/material";

const WwVideo = (props) => {
  let [classnames, setClassnames] = useState("");
  let [alignClass, setAlignClass] = useState("");
  //let [classnames, setClassnames] = useState('');

  useEffect(() => {
    if (
      props.data.style.decoration_classes !== null &&
      props.data.style.decoration_classes !== undefined
    ) {
      setClassnames(props.data.style.decoration_classes.join(" "));
    }

    //setClassnames(classnames + " slideInLeft q-pa-xs");

    if (
      props.data.style.align !== null &&
      props.data.style.align !== undefined
    ) {
      setAlignClass(props.data.style.align);
    } else {
      setAlignClass("");
    }
  }, [props.data]);

  return (
    <Grid container>
      <div
        style={{
          textAlign: "center",
          padding: "5px",
          margin: "0px 5px",
          borderRadius: "5px",
          display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block',
          background:
            "linear-gradient(to bottom, rgba(0,16,107,0.5) 0%,rgba(148,155,193,0) 58%,rgba(244,244,244,0.7) 100%)",
        }}
      >
        {/* <div id={`playdiv_${props.data.myId.self}`} class="btn btnplay""></div>
      <div id={`pausediv_${props.data.myId.self}`} class="btn btnpause" style="display:none;"></div> */}
        <video
          width="97%"
          id={props.data.myId.self}
          preload="auto"
          disablePictureInPicture
          controlsList="nodownload"
          controls={true}
        >
          <source
            src={`${sessionStorage.getItem('media_url')}video/${props.data.source}`}
            type="video/ogg"
          />
          <source
            src={`${sessionStorage.getItem('media_url')}video/${props.data.source}`}
            type="video/mp4"
          />
        </video>
      </div>
    </Grid>
  );
};

export default WwVideo;
